import { mapper } from './lodash-ext';
/**
 * @deprecated
 * Maps keys course, theme, topic into param, subparam, xsubparam
 *
 * @param {object} input - object to convert
 *
 * @returns {object} output - converted object
 *
 * @example
 * paramsMapper({
 *   course: 'basic-course',
 *   theme: 'mindset',
 *   topic: 'introduction',
 * })
 * // returns {
 * //   param: 'basic-course',
 * //   subparam: 'mindset',
 * //   xsubparam: 'introduction',
 * // }
 */

export var paramsMapper = mapper({
  param: 'course',
  subparam: 'theme',
  xsubparam: 'topic'
});
export default paramsMapper;